import { styled, makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';

export const Container = styled(Box)({
  width: '100%',
});

export const UserCard = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '24px',
  flexWrap: 'wrap',
  gap: '16px',
});

export const useStyles = makeStyles(theme => ({
  infoCard: {
    background: theme.colors.backgroundLight,
    borderRadius: theme.borderRadius,
    padding: '20px',
    marginBottom: '24px',
  },
  label: {
    fontSize: '12px',
    color: theme.colors.whiteWeak,
  },
  value: {
    fontSize: '15px',
    color: '#fff',
    marginBottom: '8px',
  },
  tableContainer: {
    background: theme.colors.backgroundLight,
    borderRadius: theme.borderRadius,
    padding: '16px',
  },
  sectionTitle: {
    fontSize: '18px',
    marginBottom: '12px',
    color: '#fff',
  },
  chipPaid: {
    backgroundColor: theme.colors.win,
    color: '#fff',
  },
  chipPending: {
    backgroundColor: theme.colors.primary,
    color: '#1E2141',
  },
  chipOverdue: {
    backgroundColor: theme.colors.loss,
    color: '#fff',
  },
  chipKiwify: {
    backgroundColor: '#7c4dff',
    color: '#fff',
  },
  chipManual: {
    backgroundColor: '#546e7a',
    color: '#fff',
  },
}));
